import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=d4360d5c&"
import script from "./UserSettings.vue?vue&type=script&lang=ts&"
export * from "./UserSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports